<a class="preview-link" target="_blank">
  <div class="image-wrapper">
    <framework-assets-image
      [assetFile]="content?.defaultAsset?.assetFiles[0]"
      (loaded)="loaded = true"
      [size]="1000"
      aspect="16/9"
    >
    </framework-assets-image>
  </div>

  <div class="content-wrapper">
    <div class="title truncate" *ngIf="content">
      <div actionLauncher="Rename" [project]="content">{{ content.name }}</div>
      <div class="version" *ngIf="content?.children?.length > 1 ">1</div>
    </div>
    <div class="date-action truncate" *ngIf="content">
      <div class="text">
        <div class="date-published"><mat-icon> schedule</mat-icon> Date Published</div>
        <div class="date">{{ content?.publishDate | date:"dd MMM, yyyy" }}</div>
      </div>

      <framework-action-dropdown
        [actions]="content | actionsPipe:'project'"
        location="content"
        [phase]="content | projectLastestPhaseFromProjectPipe"
        [project]="content"
        level="project"
      >
      </framework-action-dropdown>
    </div>
  </div>

  <framework-work-status-chip [workStatus]="content.status"></framework-work-status-chip>
</a>
